import { usePoolInfoContext } from '@/hooks/usePoolInfo';
import styles from './index.module.scss';
import cls from 'classnames';
import { useMemo } from 'react';
import { useFm } from '@web3/base-hooks';

interface Props {
  type: 'stake' | 'unstake' | 'claim';
  extraClass?: string;
}

export const RiskNotification = ({ type, extraClass }: Props) => {
  const { poolInfo } = usePoolInfoContext();
  const fm = useFm();
  const riskText = useMemo(
    () => poolInfo?.poolExtendDTO?.riskNotice?.[`${type}RiskText`] ?? '',
    [poolInfo, type]
  );

  const riskUrl = useMemo(
    () => poolInfo?.poolExtendDTO?.riskNotice?.[`${type}RiskUrl`] ?? '',
    [poolInfo, type]
  );

  const onJumpClick = () => {
    window.open(riskUrl, '_blank');
  };

  return riskText.length > 0 ? (
    <div
      className={cls(
        'text-xs font-normal leading-4.5 mt-6 mb-6',
        styles.container,
        extraClass
      )}
    >
      <span className="text-bds-red-700-normal">* </span>
      <span>{riskText}</span>
      {riskUrl.length > 0 ? (
        <span
          className="text-bds-brand-700-normal cursor-pointer"
          onClick={() => onJumpClick()}
        >
          {fm('clickToGo')}
        </span>
      ) : null}
    </div>
  ) : null;
};
